import { create } from "zustand";

const useDoneOrders = create((set) => ({
  doneOrders: [],
  doneOrdersCount: 0, // State variable to hold the count of objects in the array
  loading: true,
  setDoneOrders: (orders) => set({ doneOrders: orders, doneOrdersCount: orders.length, loading: false }),
  setLoading: (loadingState) => set({ loading: loadingState }),
}));

export default useDoneOrders;
